"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversationReducer = void 0;
const safe_clone_deep_1 = __importDefault(require("safe-clone-deep"));
const uuid_1 = require("uuid");
const constants_1 = require("../constants");
const models_1 = require("../models");
const Messages = __importStar(require("../models"));
const get_user_color_index_1 = require("../utils/get-user-color-index");
const session_1 = require("../utils/session");
const clone_pages_1 = require("./clone-pages");
const empty_conversation_1 = require("./empty-conversation");
const nav_data_1 = require("./nav-data");
let messageSequence = 1;
const transformPointInverse = (viewport, canvasX, canvasY) => ({
    x: canvasX * viewport.scale + viewport.offset.x,
    y: canvasY * viewport.scale + viewport.offset.y,
});
const addElement = (drawing, newElement) => {
    return {
        elements: { ...drawing.elements, [newElement.elementId]: newElement },
        order: [...drawing.order, newElement.elementId],
        uniqueId: drawing.uniqueId,
    };
};
const conversationReducer = (input, message) => {
    const conversation = { ...input };
    //update last timestamp
    message.UTCTimestamp = message.UTCTimestamp ?? 0;
    conversation.lastMessageTimestamp[message.participantId] =
        message.UTCTimestamp || input.lastMessageTimestamp[message.participantId];
    // process message
    if (Messages.isParticipantConnectMessage(message)) {
        // if there was o one in the session prior to connection force disconnect all previously connected people
        const forcedDisconnectParticipants = message.didStartSession
            ? Object.entries(conversation.participants)
                .filter(([_, p]) => p.status === 'active')
                .reduce((prev, [pid, p]) => {
                prev[pid] = {
                    ...p,
                    status: 'inactive',
                    disconnectUTCTimestamp: conversation.lastMessageTimestamp[pid] ?? p.connectUTCTimestamp,
                };
                return prev;
            }, {})
            : {};
        //add participant
        const oldParticipant = conversation.participants[message.participantId];
        const connectTime = oldParticipant?.connectUTCTimestamp ?? message.UTCTimestamp ?? Date.now();
        const participants = {
            ...conversation.participants,
            ...forcedDisconnectParticipants,
            [message.participantId]: {
                ...oldParticipant,
                name: message.name,
                status: 'active',
                userId: message.userId,
                colorIndex: (0, get_user_color_index_1.getUserColorIndex)(message.userId, conversation.participants),
                connectUTCTimestamp: connectTime,
            },
        };
        //if user is not currently active set device to primary
        let isDuplicate = false;
        for (const [participantId, participant] of Object.entries(participants)) {
            if (participantId !== message.participantId &&
                participant.userId === message.userId &&
                participant?.status === 'active') {
                isDuplicate = true;
            }
        }
        //update session
        const sessions = Object.keys(forcedDisconnectParticipants).length > 0
            ? (0, session_1.regenerateSessions)(participants)
            : (0, session_1.startSession)(conversation.sessions, message.participantId, connectTime);
        //set participant sscreen
        const participantDevices = {
            ...conversation.participantDevices,
            [message.participantId]: {
                ...(0, empty_conversation_1.GET_EMPTY_PARTICIPANT_DEVICE)(),
                ...conversation.participantDevices[message.participantId],
                isPrimary: isDuplicate ? undefined : true,
            },
        };
        //initialise pointer position
        const pointers = {
            ...conversation.pointers,
            [message.participantId]: conversation.pointers[message.participantId] ?? (0, empty_conversation_1.GET_EMPTY_POINTER)(),
        };
        //initialise Viewports
        const viewports = {
            ...conversation.viewports,
            [message.participantId]: conversation.viewports[message.participantId] ?? (0, empty_conversation_1.GET_EMPTY_VIEWPORT)(),
        };
        return { ...conversation, viewports, pointers, participantDevices, participants, sessions };
    }
    else if (Messages.isParticipantDeviceSetMessage(message)) {
        const oldParticipantDevice = conversation.participantDevices[message.participantId];
        const oldParticipant = conversation.participants[message.participantId];
        // if participant already exists and another device is primary, reset other devices to secondary
        const newParticipantDevices = {};
        if ((message.isPrimary && !oldParticipantDevice?.isPrimary) ||
            (message.deviceType === 'primary' && !oldParticipantDevice?.isPrimary)) {
            for (const [participantId, participant] of Object.entries(conversation.participants)) {
                if (participantId !== message.participantId &&
                    participant.userId === oldParticipant.userId &&
                    participant?.status === 'active') {
                    newParticipantDevices[participantId] = {
                        ...oldParticipantDevice,
                        isPrimary: false,
                    };
                }
            }
        }
        return {
            ...conversation,
            participantDevices: {
                ...conversation.participantDevices,
                ...newParticipantDevices,
                [message.participantId]: {
                    ...oldParticipantDevice,
                    screen: (0, safe_clone_deep_1.default)(message.screen),
                    isPrimary: message.deviceType === 'primary' ||
                        (message.isPrimary ?? oldParticipantDevice?.isPrimary),
                },
            },
        };
    }
    else if (Messages.isViewportSetMessage(message)) {
        const viewports = { ...conversation.viewports };
        //set all viewports
        message.viewports.forEach((v) => {
            const oldViewport = conversation.viewports[v.participantId];
            viewports[v.participantId] = {
                pageId: v.pageId,
                scale: v.scale,
                offset: oldViewport?.offset?.x !== v.leftOffset || oldViewport?.offset?.y !== v.topOffset
                    ? { x: v.leftOffset, y: v.topOffset }
                    : oldViewport?.offset,
                flashback: oldViewport?.flashback?.UTCTimestamp !== v?.flashback?.UTCTimestamp ||
                    oldViewport?.flashback?.playSpeed !== v?.flashback?.playSpeed ||
                    oldViewport?.flashback?.startTime !== v?.flashback?.startTime
                    ? v.flashback
                    : oldViewport?.flashback,
            };
        });
        //set rawpoint
        const pointers = message.participantId
            ? {
                ...conversation.pointers,
                [message.participantId]: {
                    position: message.rawPoint ?? conversation.pointers[message.participantId]?.position,
                    currentTool: conversation.pointers[message.participantId]?.currentTool ?? constants_1.DEFAULT_TOOL,
                    live: true,
                },
            }
            : conversation.pointers;
        return { ...conversation, pointers, viewports };
    }
    else if (Messages.isFieldFocusSetMessage(message)) {
        return {
            ...conversation,
            foci: {
                ...conversation.foci,
                [message.participantId]: { fieldName: message.fieldName, pageId: message.pageId },
            },
        };
    }
    else if (Messages.isPageInsertMessage(message)) {
        if (message.pageId === constants_1.PAGEID_ADD_PAGE)
            return conversation;
        const parentId = message.parentId !== constants_1.PAGEID_ADD_PAGE ? message.parentId : undefined;
        let pagesBefore = Object.entries(conversation.pages)
            .filter(([pid, p]) => !p.hideFromNav &&
            ((parentId && (p.parentId === parentId || pid === parentId)) || !parentId))
            .map(([pid, p]) => p)
            .sort((a, b) => (b.index ?? -1) - (a.index ?? -1))
            .find(() => true);
        const insertIndex = (pagesBefore?.index ?? -1) + 1;
        const pageTypeDetails = models_1.PAGE_TYPES[message.pageType];
        const pages = {
            ...Object.entries(conversation.pages).reduce((prev, [id, v]) => {
                prev[id] = v.index < insertIndex ? v : { ...v, index: v.index + 1 };
                return prev;
            }, {}),
            [message.pageId]: {
                ...(0, empty_conversation_1.GET_EMPTY_PAGE)(),
                index: message.index ?? insertIndex,
                createdByParticipantId: message.participantId,
                createdTimestamp: message.UTCTimestamp,
                isHidden: message.isHidden,
                fields: (0, safe_clone_deep_1.default)(message.fields) ?? (0, empty_conversation_1.GET_EMPTY_PAGE)().fields,
                label: message.label ?? pageTypeDetails.defaultLabel ?? '',
                attachments: (0, safe_clone_deep_1.default)(message.attachments) ?? (0, empty_conversation_1.GET_EMPTY_PAGE)().attachments,
                pageType: message.pageType,
                parentId,
                hideFromNav: pageTypeDetails.hideFromNav,
                hideToolbar: pageTypeDetails.hideToolbar,
            },
        };
        return {
            ...conversation,
            pages,
            navData: (0, nav_data_1.buildNavData)(pages),
        };
    }
    else if (Messages.isPageRenameMessage(message)) {
        const pages = (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => ({
            label: message.label,
        }));
        return {
            ...conversation,
            pages,
            navData: (0, nav_data_1.buildNavData)(pages),
        };
    }
    else if (Messages.isAttachmentRegisterMessage(message)) {
        return {
            ...conversation,
            pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => ({
                attachments: {
                    ...n.attachments,
                    [message.key]: message.url,
                },
            })),
        };
    }
    else if (Messages.isAttachmentDeregisterMessage(message)) {
        return {
            ...conversation,
            pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => {
                const newAttachments = Object.keys(n.attachments).reduce((accum, curr) => {
                    if (curr !== message.key) {
                        accum[curr] = n.attachments[curr];
                    }
                    return accum;
                }, {});
                return {
                    attachments: {
                        ...newAttachments,
                    },
                };
            }),
        };
    }
    else if (Messages.isPageDeleteMessage(message)) {
        if (!conversation.pages[message.pageId]) {
            return conversation;
        }
        const isFolder = message.pageId in conversation.pages &&
            conversation.pages[message.pageId].pageType === 'folder';
        let pages = { ...conversation.pages };
        if (isFolder) {
            const children = Object.keys(conversation.pages)
                .map((x) => ({
                id: x,
                ...conversation.pages[x],
            }))
                .filter((x) => x.parentId === message.pageId)
                .map((x) => x.id);
            for (const pageId of children) {
                pages = (0, clone_pages_1.clonePages)(pages, pageId, (n) => ({
                    isHidden: true,
                }));
            }
        }
        pages = (0, clone_pages_1.clonePages)(pages, message.pageId, (n) => ({
            isHidden: true,
        }));
        return { ...conversation, pages, navData: (0, nav_data_1.buildNavData)(pages) };
    }
    else if (Messages.isPageUndeleteMessage(message)) {
        const pages = (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => ({
            isHidden: false,
        }));
        return { ...conversation, pages, navData: (0, nav_data_1.buildNavData)(pages) };
    }
    else if (Messages.isSetPointerMessage(message)) {
        const partcipantPointer = conversation.pointers[message.participantId];
        return {
            ...conversation,
            pointers: {
                ...conversation.pointers,
                [message.participantId]: {
                    ...partcipantPointer,
                    position: !message.point
                        ? null
                        : { x: message.point.x, y: message.point.y } ?? partcipantPointer?.position,
                    live: false,
                },
            },
        };
    }
    else if (Messages.isPointerToolSetMessage(message)) {
        const participantPointer = conversation.pointers[message.participantId];
        return {
            ...conversation,
            pointers: {
                ...conversation.pointers,
                [message.participantId]: {
                    ...participantPointer,
                    currentTool: message.currentTool ?? participantPointer?.currentTool ?? constants_1.DEFAULT_TOOL,
                },
            },
        };
    }
    else if (Messages.isSpotlightSetMessage(message)) {
        if (message.highlight === null) {
            return {
                ...conversation,
                spotlight: { highlight: null, participantId: '', pageId: null },
            };
        }
        const participantPointer = conversation.pointers[message.participantId];
        return {
            ...conversation,
            spotlight: {
                highlight: {
                    x: message.highlight.x,
                    y: message.highlight.y,
                    width: message.highlight.width,
                },
                pageId: message.pageId,
                participantId: message.participantId,
            },
            pointers: {
                ...conversation.pointers,
                [message.participantId]: {
                    ...participantPointer,
                    live: true,
                    position: transformPointInverse(conversation.viewports[message.participantId], message.highlight.x, message.highlight.y),
                },
            },
        };
    }
    else if (Messages.isAlertDisplayMessage(message)) {
        if (message.targetParticipantId &&
            message.targetParticipantId !== conversation.myParticipantId) {
            //if message isnt for me or a broadcast ignore
            return conversation;
        }
        return {
            ...conversation,
            alertMessage: {
                text: message.text,
                uniqueId: (0, uuid_1.v4)(),
                type: message.type,
                code: message.code,
                data: message.data,
                targetParticipantId: message.targetParticipantId,
                UTCTimestamp: message.UTCTimestamp ?? Date.now(),
                senderParticipantId: message.participantId,
            },
        };
    }
    else if (Messages.isFieldSetMessage(message)) {
        const result = {
            ...conversation,
            pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => ({
                fields: {
                    ...n.fields,
                    [message.fieldName]: message.jsonValue === 'undefined' || message.jsonValue === undefined
                        ? undefined
                        : message.jsonValue === null
                            ? null
                            : JSON.parse(message.jsonValue),
                },
            })),
        };
        return result;
    }
    else if (Messages.isPageNotesSetMessage(message)) {
        const res = {
            ...conversation,
            pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => ({
                note: {
                    formattedText: message.formattedText,
                    isEditing: message.isEditing,
                    participantId: message.participantId,
                    plainText: message.plainText,
                },
            })),
        };
        return res;
    }
    else if (Messages.isPageAttributesMessage(message)) {
        const res = {
            ...conversation,
            pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => ({
                backgroundColor: message.backgroundColor,
            })),
        };
        return res;
    }
    else if (Messages.isArtifactTextBlockMessage(message)) {
        if (conversation.pages?.[message.pageId]?.artifacts?.[message.artifactId]?.artifactType !==
            'removed') {
            return {
                ...conversation,
                pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => {
                    const oldValue = n.artifacts[message.artifactId];
                    return {
                        artifacts: {
                            ...n.artifacts,
                            [message.artifactId]: {
                                ...oldValue,
                                participantId: message.participantId,
                                artifactType: 'text-block',
                                fontSize: message.fontSize ?? oldValue?.fontSize,
                                text: message.text ?? oldValue?.text,
                                isEditing: message.isEditing ?? oldValue?.isEditing,
                                zIndex: messageSequence++,
                            },
                        },
                    };
                }),
            };
        }
        return conversation;
    }
    else if (Messages.isArtifactStickyMessage(message)) {
        if (conversation.pages?.[message.pageId]?.artifacts?.[message.artifactId]?.artifactType !==
            'removed') {
            return {
                ...conversation,
                pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => {
                    const oldValue = n.artifacts[message.artifactId];
                    return {
                        artifacts: {
                            ...n.artifacts,
                            [message.artifactId]: {
                                ...oldValue,
                                artifactType: 'sticky',
                                participantId: message.participantId,
                                text: message.text ?? oldValue?.text,
                                isEditing: message.isEditing ?? oldValue?.isEditing,
                                stickyType: message.stickyType ?? oldValue?.stickyType,
                                arrow: message.arrow ?? oldValue?.arrow,
                                strikethrough: message.strikethrough ?? oldValue?.strikethrough,
                                zIndex: messageSequence++,
                            },
                        },
                    };
                }),
            };
        }
        return conversation;
    }
    else if (Messages.isArtifactRedactionMessage(message)) {
        if (conversation.pages?.[message.pageId]?.artifacts?.[message.artifactId]?.artifactType !==
            'removed') {
            return {
                ...conversation,
                pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => {
                    const oldValue = n.artifacts[message.artifactId];
                    return {
                        artifacts: {
                            ...n.artifacts,
                            [message.artifactId]: {
                                ...oldValue,
                                artifactType: 'redaction',
                                participantId: message.participantId,
                                isEditing: message.isEditing ?? oldValue?.isEditing,
                                zIndex: messageSequence++,
                            },
                        },
                    };
                }),
            };
        }
        return conversation;
    }
    else if (Messages.isArtifactPositionMessage(message)) {
        if (conversation.pages?.[message.pageId]?.artifacts?.[message.artifactId]?.artifactType !==
            'removed') {
            return {
                ...conversation,
                pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => {
                    const oldValue = n.artifacts[message.artifactId];
                    return {
                        artifacts: {
                            ...n.artifacts,
                            [message.artifactId]: {
                                ...oldValue,
                                height: message.height,
                                left: message.left,
                                top: message.top,
                                width: message.width,
                                yOffset: message.yOffset ?? oldValue?.yOffset,
                                xOffset: message.xOffset ?? oldValue?.xOffset,
                                anchorElementName: message.anchorElementName ?? oldValue?.anchorElementName,
                                elastic: message.elastic ?? oldValue?.elastic ?? 'none',
                                zIndex: messageSequence++,
                                participantId: oldValue?.participantId ?? message.participantId,
                            },
                        },
                    };
                }),
            };
        }
        return conversation;
    }
    else if (Messages.isArtifactRemoveMessage(message)) {
        return {
            ...conversation,
            pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => ({
                artifacts: { ...n.artifacts, [message.artifactId]: { artifactType: 'removed' } },
            })),
        };
    }
    else if (Messages.isParticipantDisconnectMessage(message)) {
        const disconnectedUser = conversation.participants[message.participantId];
        if (!message.participantId || !disconnectedUser) {
            // not sure how it happens that disconnect occasionally sent with no participantId
            return conversation;
        }
        const disconnectedUserId = disconnectedUser.userId;
        const disconnectTime = message.UTCTimestamp ?? disconnectedUser.connectUTCTimestamp ?? Date.now();
        const participants = {
            ...conversation.participants,
            [message.participantId]: {
                ...conversation.participants[message.participantId],
                status: 'inactive',
                disconnectUTCTimestamp: disconnectTime,
            },
        };
        // anyone following the disconnect user should stop & anyone the disconnected user is following should stop
        const followingUsers = Object.keys(conversation.followingUsers).reduce((prev, follower) => {
            const masterUser = conversation.followingUsers[follower];
            if (!((masterUser.userId === disconnectedUserId && masterUser.followType === 'live') ||
                follower === disconnectedUserId)) {
                prev[follower] = masterUser;
            }
            return prev;
        }, {});
        //update session
        const sessions = (0, session_1.endSession)(conversation.sessions, participants, message.participantId, disconnectTime);
        return { ...conversation, followingUsers, participants, sessions };
    }
    else if (Messages.isAnnotationLinePointAddMessage(message)) {
        const pages = (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => {
            if (n.drawing.elements[message.elementId]) {
                //line segment already exists add point
                const currentElement = n.drawing.elements[message.elementId];
                if ((0, models_1.isLineSegment)(currentElement)) {
                    return {
                        drawing: {
                            ...n.drawing,
                            elements: {
                                ...n.drawing.elements,
                                [message.elementId]: {
                                    ...currentElement,
                                    points: [...currentElement.points, [...message.point]],
                                },
                            },
                        },
                    };
                }
                else {
                    return {};
                }
            }
            else {
                //new line segment
                const newLine = {
                    type: 'line-segment',
                    points: [[...message.point]],
                    width: message.width,
                    participantId: message.participantId,
                    mode: message.mode,
                    elementId: message.elementId,
                    colorIndex: message.colorIndex,
                    complete: false,
                    yOffset: 0,
                    xOffset: null,
                };
                return { drawing: addElement(n.drawing, newLine) };
            }
        });
        const rawPoint = conversation.viewports[message.participantId]
            ? transformPointInverse(conversation.viewports[message.participantId], message.point[0], message.point[1])
            : null;
        //set rawpoint
        const pointers = {
            ...conversation.pointers,
            [message.participantId]: {
                position: rawPoint,
                currentTool: message.mode,
                live: true,
            },
        };
        return { ...conversation, pages, pointers };
    }
    else if (Messages.isAnnotationLineEndMessage(message)) {
        return {
            ...conversation,
            pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, (n) => {
                const currentElement = n.drawing.elements[message.elementId];
                if (!currentElement) {
                    const newLine = {
                        type: 'line-segment',
                        points: (0, safe_clone_deep_1.default)(message.points) ?? [],
                        width: message.width ?? 1,
                        participantId: message.participantId,
                        mode: message.mode,
                        elementId: message.elementId,
                        colorIndex: message.colorIndex,
                        complete: true,
                        yOffset: message.yOffset,
                        xOffset: message.xOffset,
                        anchorElementName: message.anchorElementName ?? '',
                    };
                    return { drawing: addElement(n.drawing, newLine) };
                }
                else if ((0, models_1.isLineSegment)(currentElement)) {
                    return {
                        drawing: {
                            ...n.drawing,
                            elements: {
                                ...n.drawing.elements,
                                [message.elementId]: {
                                    ...currentElement,
                                    complete: true,
                                    anchorElementName: message.anchorElementName,
                                    yOffset: message.yOffset,
                                    xOffset: message.xOffset,
                                    points: (0, safe_clone_deep_1.default)(message.points) ?? currentElement.points,
                                },
                            },
                        },
                    };
                }
                throw new Error('incorrect element type');
            }),
        };
    }
    else if (Messages.isViewportFollowingSetMessage(message)) {
        const followingUsers = {
            ...conversation.followingUsers,
        };
        if (message.masterUserId) {
            followingUsers[message.followingUserId] = {
                userId: message.masterUserId,
                followType: message.followType,
            };
        }
        else {
            delete followingUsers[message.followingUserId];
        }
        return { ...conversation, followingUsers };
    }
    else if (Messages.isNavReorderMessage(message)) {
        const pages = (0, nav_data_1.setPageIndexes)(conversation.pages, (0, safe_clone_deep_1.default)(message.navData));
        return { ...conversation, navData: (0, nav_data_1.buildNavData)(pages), pages };
    }
    else if (Messages.isUserSetMessage(message)) {
        const participants = {};
        Object.entries(conversation.participants).forEach(([pid, p]) => (participants[pid] = p.userId === message.userId ? { ...p, name: message.name } : p));
        return { ...conversation, participants };
    }
    else if ((0, models_1.isAnnotationClearMessage)(message)) {
        return {
            ...conversation,
            pages: (0, clone_pages_1.clonePages)(conversation.pages, message.pageId, () => ({
                drawing: (0, empty_conversation_1.GET_EMPTY_PAGE)().drawing,
                ...(message.clear === 'all' ? { artifacts: (0, empty_conversation_1.GET_EMPTY_PAGE)().artifacts } : {}),
            })),
        };
    }
    else if (Messages.isNotificationEventMessage(message)) {
        //noop
        return conversation;
    }
    else if (Messages.isSessionRecordingSetMessage(message)) {
        return {
            ...conversation,
            sessionRecordingOptions: {
                recording: message.recording,
                updatedByParticipantId: message.participantId,
                updatedTimestamp: message.UTCTimestamp ?? null,
            },
        };
    }
    else if (Messages.isCommentarySetMessage(message)) {
        const makeManual = message.trigger === 'manual'
            ? undefined
            : Object.entries(conversation.commentary).find(([id, c]) => c.trigger === message.trigger &&
                c.triggerPageId === message.triggerPageId &&
                id !== message.commentaryId);
        return {
            ...conversation,
            commentary: {
                ...conversation.commentary,
                ...(makeManual
                    ? { [makeManual[0]]: { ...makeManual[1], trigger: 'manual', triggerPageId: undefined } }
                    : {}),
                [message.commentaryId]: {
                    label: message.label,
                    playback: message.playback,
                    trigger: message.trigger,
                    triggerPageId: message.triggerPageId,
                    durationMs: message.durationMs,
                    expertParticipantId: message.expertParticipantId,
                    UTCTimestamp: message.startUTCTimestamp,
                },
            },
        };
    }
    else if (Messages.isCommentaryDeleteMessage(message)) {
        const commentary = {
            ...conversation.commentary,
        };
        delete commentary[message.commentaryId];
        return { ...conversation, commentary };
    }
    else if (Messages.isMessageCollection(message)) {
        throw new Error('Collections cannot be handled by the reducer');
    }
    else if (Messages.isStateUndoMessage(message) || Messages.isStateRedoMessage(message)) {
        throw new Error('Undo/redo cannot be handled by the reducer');
    }
    else if (message.messageType === 'page-reorder' ||
        message.messageType === 'set-focus') {
        //noop legacy v1 messages that were not cleaned up and can still reside in v2 files
        //TODO clean up when move to v3
        return conversation;
    }
    // Could be any outdated message, so log it and return the conversation unchanged
    console.error('Unknown message', message);
    return conversation;
};
exports.conversationReducer = conversationReducer;
